package pl.decks.personal.styles

import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.breakpoint.BreakpointSizes

@InitSilk
fun setSiteBreakpoints(ctx: InitSilkContext) {
    ctx.theme.breakpoints = BreakpointSizes(
        sm = SiteLayout.Breakpoint.sm,
        md = SiteLayout.Breakpoint.md,
        lg = SiteLayout.Breakpoint.lg,
        xl = SiteLayout.Breakpoint.xl,
        xxl = SiteLayout.Breakpoint.xxl,
    )
}
